module.exports = __webpack_public_path__ + "img/reeducation@2x.31955bb7.webp";